export function isFunction(item) {
	const obj = _.isObject(item)
	if (!obj) return false

	const isFn = typeof item === 'function'
	const isComponent = typeof item === 'object' && typeof item.type === 'function'

	return isFn || isComponent
}
